let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f93ss")).then(() => parcelRequire('cfM0Y'));